// export reducers
export {
  getEventLists as getEventListsReducer,
  getSubeventLists as getSubeventListsReducer,
  getEventPromoted as getEventPromotedReducer,
  getEventDetail as getEventDetailReducer,
  getEventFilter as getEventFilterReducer,
  getEventCategories as getEventCategoriesReducer,
  getOtherEvents as getOtherEventsReducer,
  likedEvents as likedEventsReducer,
} from './reducers'

// export actions
export {
  getEventLists as getEventListsAction,
  getSubeventLists as getSubeventListsAction,
  loadMoreEvents as loadMoreEventsAction,
  getEventPromoted as getEventPromotedAction,
  getEventDetail as getEventDetailAction,
  getEventFilter as getEventFilterAction,
  getEventCategories as getEventCategoriesAction,
  getOtherEvents as getOtherEventsAction,
  likeEvent as likeEventAction,
} from './actions'



// WEBPACK FOOTER //
// ./src/modules/Event/index.js